import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SatelliteLock } from 'src/app/core/interfaces/satelliteLock';
import { SatelliteLockStateDevice } from 'src/app/core/enums/satelliteLockStateDevice.enum';

@Component({
  selector: 'app-item-satellite-lock',
  templateUrl: './item-satellite-lock.component.html',
  styleUrls: ['./item-satellite-lock.component.scss']
})

export class ItemSatelliteLockComponent {
  @Input() satelliteLock: SatelliteLock;

  constructor(
    private router: Router
  ) { }

  openDetail(): void {
    if (this.satelliteLock && this.satelliteLock.imei) {
      this.router.navigate(['administration/satellite-lock/detail', this.satelliteLock.imei]);
    }
  }

  getStateDeviceText(): string {
    if (!this.satelliteLock || !this.satelliteLock.stateDevice) return '-';
    const stateMap = {
      [SatelliteLockStateDevice.ACTIVE]: 'Activo',
      [SatelliteLockStateDevice.INACTIVE]: 'Inactivo',
      [SatelliteLockStateDevice.IN_MAINTENANCE]: 'En mantenimiento'
    };
    return stateMap[this.satelliteLock.stateDevice] || this.satelliteLock.stateDevice.toString();
  }
}
